export const environment = {
  production: true,
  apiUrl: `${document.location.origin}/api`,
  referralCodeUrl: `https://www.tinselcrm.com`,
  square: {
    webSdkUrl: 'https://web.squarecdn.com/v1/square.js'
  },
  tinselPay: {
    tokenizationKey: 'G563z7-R2SZ5y-7sfhR4-U4td78',
    passFeePercent: 3.95
  },
  version: '2.5.12',
  map: 'v1.public.eyJqdGkiOiI3OTI2MzIzOS0xYjk5LTQxOTQtOTg1Mi0zNGFhODdjNmEyODEifYu7oK6bRq_372gAT0XMMIMARCgc6IKyJA8nfptiELuoYTNTbQ-jtggtXIj5Cq9-dWS-9oe2x-lI7SPYm78ALI41CkVpFS_i9xUXxY21l5QnirXE26mkEcE8TPmREnOXSAe2Bi3BE03TpQdCS1EWoK-iDdRu548vKRrfjnsh5CwNGikxTJEdHWt_ZQirX1-DPf9qqk0ls30YGOf4mA8TDQLqpI674cfm57m9q3bHFLAxwiAy6b6cV5e8WSKjON5526xLvlCZIrN9t7hwUXquMaHuJkwZsGpSz9hYwNX-LF_GXnGYMmW9PlTLpECRWcX3LwrDB3EAyW2RL5cr76yotNo.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx'
};
